import Vue from 'vue'
import store from 'store'

const expirePlugin = require('store/plugins/expire')
const updatePlugin = require('store/plugins/update')
store.addPlugin(expirePlugin)
store.addPlugin(updatePlugin)

// Bind store to Vue.
Vue.$storage = store
Object.defineProperty(Vue.prototype, '$storage', {
  get () {
    return store
  }
})



// WEBPACK FOOTER //
// ./src/app/plugins/storage.js